<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Login v1 -->
    <div class="card mb-0">
      <div class="card-header justify-content-center bg-secondary">
        <a href="#" target="_self" class="brand-logo mb-0 mt-0">
          <img src="{{ coreConfig.app.logo.light }}" alt="brand-logo" height="50"/>
        </a>
      </div>
      <div class="card-body pt-2">
        <h4 class="card-title mb-1">Accedi a {{sectionAccessName}}!</h4>
        <p class="card-text mb-2">Per favore accedi al tuo account per continuare</p>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label class="label" for="username">Username</label>
            <input id="username" class="form-control" formControlName="username" placeholder="Username">
            <div *ngIf="loginForm.get('username').errors?.required && loginForm.get('username').touched"
                 class="text-danger">
              Username is required
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label for="password">Password</label>
              <a routerLink="/authentication/forgot-password-v1">
                <small>Non ricordi la password?</small>
              </a>
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input id="password" class="form-control form-control-merge" formControlName="password"
                     [type]="passwordTextType ? 'text' : 'password'" placeholder="Password">
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                ><i
                  class="feather font-small-4"
                  [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                  (click)="togglePasswordTextType()"
                ></i
                ></span>
              </div>
            </div>
            <div *ngIf="loginForm.get('password').errors?.required && loginForm.get('password').touched"
                 class="text-danger">
              Password is required
            </div>
          </div>
          <button type="submit" [disabled]="!loginForm.valid" class="submit ">Login</button>
        </form>


        <p class="text-center mt-2">
          <span>Nuovo nella nostra piattaforma?</span>
          <a routerLink="/authentication/register">
            <span>&nbsp;Crea un account</span>
          </a>
        </p>

      </div>
    </div>
    <!-- /Login v1 -->
  </div>
</div>


<ng-template #wrongPasswordModal let-modal>
  <div class="modal-header bg-primary">
    <h5 class="modal-title text-white" id="tulero-token-cart-modal">Credenziali Errate</h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ validationErrorMessage }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Chiudi</button>
  </div>
</ng-template>
